import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const RESIZE_OBSERVER_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (event: ErrorEvent) => {
  if (RESIZE_OBSERVER_ERRORS.includes(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loading spinner after React mounts
const loadingSpinner = document.getElementById('loading-spinner');
if (loadingSpinner) {
  loadingSpinner.classList.add('fade-out');
  // Remove from DOM after animation completes
  setTimeout(() => {
    loadingSpinner.remove();
  }, 500);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
